/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: { input: any; output: any; }
};

export type AccessToken = {
  __typename?: 'AccessToken';
  client?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  expireAt?: Maybe<Scalars['DateTime']['output']>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  token: Scalars['String']['output'];
  tokenType?: Maybe<Enum_Accesstoken_Tokentype>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userAgent?: Maybe<Scalars['JSON']['output']>;
  userId?: Maybe<UsersPermissionsUser>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type AccessTokenEntityResponseCollection = {
  __typename?: 'AccessTokenEntityResponseCollection';
  nodes: Array<AccessToken>;
  pageInfo: Pagination;
};

export type AccessTokenFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AccessTokenFiltersInput>>>;
  client?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  deletedAt?: InputMaybe<DateTimeFilterInput>;
  deviceId?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  expireAt?: InputMaybe<DateTimeFilterInput>;
  metaData?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<AccessTokenFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AccessTokenFiltersInput>>>;
  os?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  token?: InputMaybe<StringFilterInput>;
  tokenType?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  userAgent?: InputMaybe<JsonFilterInput>;
  userId?: InputMaybe<UsersPermissionsUserFiltersInput>;
  uuid?: InputMaybe<StringFilterInput>;
};

export type AccessTokenInput = {
  client?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenType?: InputMaybe<Enum_Accesstoken_Tokentype>;
  userAgent?: InputMaybe<Scalars['JSON']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type AiModel = {
  __typename?: 'AiModel';
  book?: Maybe<Book>;
  categoryAnalysis?: Maybe<CategoryAnalysis>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  factCheck?: Maybe<FactCheck>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  religiousTransparency?: Maybe<ReligiousTransparency>;
  sexuallyInappropriate?: Maybe<SexuallyInappropriate>;
  type?: Maybe<Enum_Aimodel_Type>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type AiModelEntityResponseCollection = {
  __typename?: 'AiModelEntityResponseCollection';
  nodes: Array<AiModel>;
  pageInfo: Pagination;
};

export type AiModelFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AiModelFiltersInput>>>;
  book?: InputMaybe<BookFiltersInput>;
  categoryAnalysis?: InputMaybe<CategoryAnalysisFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  deletedAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  factCheck?: InputMaybe<FactCheckFiltersInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  metadata?: InputMaybe<JsonFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AiModelFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AiModelFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  religiousTransparency?: InputMaybe<ReligiousTransparencyFiltersInput>;
  sexuallyInappropriate?: InputMaybe<SexuallyInappropriateFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  uuid?: InputMaybe<StringFilterInput>;
};

export type AiModelInput = {
  book?: InputMaybe<Scalars['ID']['input']>;
  categoryAnalysis?: InputMaybe<Scalars['ID']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  factCheck?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  religiousTransparency?: InputMaybe<Scalars['ID']['input']>;
  sexuallyInappropriate?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Enum_Aimodel_Type>;
  url?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type AiModelRelationResponseCollection = {
  __typename?: 'AiModelRelationResponseCollection';
  nodes: Array<AiModel>;
};

export type Asset = {
  __typename?: 'Asset';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
  key?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  pageImage?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  section?: Maybe<Section>;
  subSections: Array<Maybe<SubSection>>;
  subSections_connection?: Maybe<SubSectionRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};


export type AssetSubSectionsArgs = {
  filters?: InputMaybe<SubSectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AssetSubSections_ConnectionArgs = {
  filters?: InputMaybe<SubSectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AssetEntityResponseCollection = {
  __typename?: 'AssetEntityResponseCollection';
  nodes: Array<Asset>;
  pageInfo: Pagination;
};

export type AssetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AssetFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  deletedAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  key?: InputMaybe<StringFilterInput>;
  metadata?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<AssetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AssetFiltersInput>>>;
  pageImage?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  section?: InputMaybe<SectionFiltersInput>;
  subSections?: InputMaybe<SubSectionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  uuid?: InputMaybe<StringFilterInput>;
};

export type AssetInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  pageImage?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  section?: InputMaybe<Scalars['ID']['input']>;
  subSections?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type AssetRelationResponseCollection = {
  __typename?: 'AssetRelationResponseCollection';
  nodes: Array<Asset>;
};

export type Book = {
  __typename?: 'Book';
  aiModels: Array<Maybe<AiModel>>;
  aiModels_connection?: Maybe<AiModelRelationResponseCollection>;
  author?: Maybe<Scalars['JSON']['output']>;
  categoryAnalyses: Array<Maybe<CategoryAnalysis>>;
  categoryAnalyses_connection?: Maybe<CategoryAnalysisRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  factChecks: Array<Maybe<FactCheck>>;
  factChecks_connection?: Maybe<FactCheckRelationResponseCollection>;
  isProcessed?: Maybe<Scalars['Boolean']['output']>;
  priceCounts?: Maybe<Scalars['Float']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedYear?: Maybe<Scalars['Int']['output']>;
  religiousTransparencies: Array<Maybe<ReligiousTransparency>>;
  religiousTransparencies_connection?: Maybe<ReligiousTransparencyRelationResponseCollection>;
  sections: Array<Maybe<Section>>;
  sections_connection?: Maybe<SectionRelationResponseCollection>;
  sexuallyInappropriates: Array<Maybe<SexuallyInappropriate>>;
  sexuallyInappropriates_connection?: Maybe<SexuallyInappropriateRelationResponseCollection>;
  subSections: Array<Maybe<SubSection>>;
  subSections_connection?: Maybe<SubSectionRelationResponseCollection>;
  subject?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tokenCounts?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};


export type BookAiModelsArgs = {
  filters?: InputMaybe<AiModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BookAiModels_ConnectionArgs = {
  filters?: InputMaybe<AiModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BookCategoryAnalysesArgs = {
  filters?: InputMaybe<CategoryAnalysisFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BookCategoryAnalyses_ConnectionArgs = {
  filters?: InputMaybe<CategoryAnalysisFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BookFactChecksArgs = {
  filters?: InputMaybe<FactCheckFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BookFactChecks_ConnectionArgs = {
  filters?: InputMaybe<FactCheckFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BookReligiousTransparenciesArgs = {
  filters?: InputMaybe<ReligiousTransparencyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BookReligiousTransparencies_ConnectionArgs = {
  filters?: InputMaybe<ReligiousTransparencyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BookSectionsArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BookSections_ConnectionArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BookSexuallyInappropriatesArgs = {
  filters?: InputMaybe<SexuallyInappropriateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BookSexuallyInappropriates_ConnectionArgs = {
  filters?: InputMaybe<SexuallyInappropriateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BookSubSectionsArgs = {
  filters?: InputMaybe<SubSectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BookSubSections_ConnectionArgs = {
  filters?: InputMaybe<SubSectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BookEntityResponseCollection = {
  __typename?: 'BookEntityResponseCollection';
  nodes: Array<Book>;
  pageInfo: Pagination;
};

export type BookFiltersInput = {
  aiModels?: InputMaybe<AiModelFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<BookFiltersInput>>>;
  author?: InputMaybe<JsonFilterInput>;
  categoryAnalyses?: InputMaybe<CategoryAnalysisFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  deletedAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  factChecks?: InputMaybe<FactCheckFiltersInput>;
  isProcessed?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<BookFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BookFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  publishedYear?: InputMaybe<IntFilterInput>;
  religiousTransparencies?: InputMaybe<ReligiousTransparencyFiltersInput>;
  sections?: InputMaybe<SectionFiltersInput>;
  sexuallyInappropriates?: InputMaybe<SexuallyInappropriateFiltersInput>;
  subSections?: InputMaybe<SubSectionFiltersInput>;
  subject?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  uuid?: InputMaybe<StringFilterInput>;
};

export type BookInput = {
  aiModels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  author?: InputMaybe<Scalars['JSON']['input']>;
  categoryAnalyses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  factChecks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedYear?: InputMaybe<Scalars['Int']['input']>;
  religiousTransparencies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sections?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sexuallyInappropriates?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subSections?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryAnalysis = {
  __typename?: 'CategoryAnalysis';
  aiModels: Array<Maybe<AiModel>>;
  aiModels_connection?: Maybe<AiModelRelationResponseCollection>;
  book?: Maybe<Book>;
  category?: Maybe<Enum_Categoryanalysis_Category>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  inputPrice?: Maybe<Scalars['Float']['output']>;
  inputTokens?: Maybe<Scalars['Long']['output']>;
  judgeOutput?: Maybe<Scalars['String']['output']>;
  judgeSummary?: Maybe<Scalars['String']['output']>;
  leftistOutput?: Maybe<Scalars['String']['output']>;
  observedDeception?: Maybe<Scalars['String']['output']>;
  outputPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Long']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  rating?: Maybe<Enum_Categoryanalysis_Rating>;
  rightistOutput?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Section>;
  subSection?: Maybe<SubSection>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Long']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  validationPercentage?: Maybe<Scalars['Int']['output']>;
};


export type CategoryAnalysisAiModelsArgs = {
  filters?: InputMaybe<AiModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CategoryAnalysisAiModels_ConnectionArgs = {
  filters?: InputMaybe<AiModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CategoryAnalysisEntityResponseCollection = {
  __typename?: 'CategoryAnalysisEntityResponseCollection';
  nodes: Array<CategoryAnalysis>;
  pageInfo: Pagination;
};

export type CategoryAnalysisFiltersInput = {
  aiModels?: InputMaybe<AiModelFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<CategoryAnalysisFiltersInput>>>;
  book?: InputMaybe<BookFiltersInput>;
  category?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  deletedAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  inputPrice?: InputMaybe<FloatFilterInput>;
  inputTokens?: InputMaybe<LongFilterInput>;
  judgeOutput?: InputMaybe<StringFilterInput>;
  judgeSummary?: InputMaybe<StringFilterInput>;
  leftistOutput?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CategoryAnalysisFiltersInput>;
  observedDeception?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<CategoryAnalysisFiltersInput>>>;
  outputPrice?: InputMaybe<FloatFilterInput>;
  outputTokens?: InputMaybe<LongFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  rating?: InputMaybe<StringFilterInput>;
  rightistOutput?: InputMaybe<StringFilterInput>;
  section?: InputMaybe<SectionFiltersInput>;
  subSection?: InputMaybe<SubSectionFiltersInput>;
  totalPrice?: InputMaybe<FloatFilterInput>;
  totalTokens?: InputMaybe<LongFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  uuid?: InputMaybe<StringFilterInput>;
  validationPercentage?: InputMaybe<IntFilterInput>;
};

export type CategoryAnalysisInput = {
  aiModels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  book?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Enum_Categoryanalysis_Category>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  inputPrice?: InputMaybe<Scalars['Float']['input']>;
  inputTokens?: InputMaybe<Scalars['Long']['input']>;
  judgeOutput?: InputMaybe<Scalars['String']['input']>;
  judgeSummary?: InputMaybe<Scalars['String']['input']>;
  leftistOutput?: InputMaybe<Scalars['String']['input']>;
  observedDeception?: InputMaybe<Scalars['String']['input']>;
  outputPrice?: InputMaybe<Scalars['Float']['input']>;
  outputTokens?: InputMaybe<Scalars['Long']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rating?: InputMaybe<Enum_Categoryanalysis_Rating>;
  rightistOutput?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['ID']['input']>;
  subSection?: InputMaybe<Scalars['ID']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  totalTokens?: InputMaybe<Scalars['Long']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  validationPercentage?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryAnalysisRelationResponseCollection = {
  __typename?: 'CategoryAnalysisRelationResponseCollection';
  nodes: Array<CategoryAnalysis>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteMutationResponse = {
  __typename?: 'DeleteMutationResponse';
  documentId: Scalars['ID']['output'];
};

export enum Enum_Accesstoken_Tokentype {
  Access = 'ACCESS',
  Reset = 'RESET'
}

export enum Enum_Aimodel_Type {
  CategoryDetection = 'categoryDetection',
  FactCheck = 'factCheck',
  ReligiousTransparency = 'religiousTransparency',
  SexuallyInappropriate = 'sexuallyInappropriate'
}

export enum Enum_Categoryanalysis_Category {
  GenderAndSexuality = 'Gender_and_Sexuality',
  None = 'NONE',
  RacialAndEthnicJustice = 'Racial_and_Ethnic_Justice'
}

export enum Enum_Categoryanalysis_Rating {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  None = 'NONE'
}

export enum Enum_Feedback_Suggestedcategory {
  GenderAndSexuality = 'Gender_and_Sexuality',
  None = 'NONE',
  RacialAndEthnicJustice = 'Racial_and_Ethnic_Justice'
}

export enum Enum_Feedback_Suggestedrating {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  None = 'NONE'
}

export type FactCheck = {
  __typename?: 'FactCheck';
  aiModels: Array<Maybe<AiModel>>;
  aiModels_connection?: Maybe<AiModelRelationResponseCollection>;
  book?: Maybe<Book>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  inputPrice?: Maybe<Scalars['Float']['output']>;
  inputTokens?: Maybe<Scalars['Long']['output']>;
  isFactuallyCorrect?: Maybe<Scalars['Boolean']['output']>;
  ocrResult?: Maybe<Scalars['String']['output']>;
  ocrText?: Maybe<Scalars['String']['output']>;
  outputPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Long']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reasoning?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Section>;
  subSection?: Maybe<SubSection>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Long']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};


export type FactCheckAiModelsArgs = {
  filters?: InputMaybe<AiModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type FactCheckAiModels_ConnectionArgs = {
  filters?: InputMaybe<AiModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FactCheckEntityResponseCollection = {
  __typename?: 'FactCheckEntityResponseCollection';
  nodes: Array<FactCheck>;
  pageInfo: Pagination;
};

export type FactCheckFiltersInput = {
  aiModels?: InputMaybe<AiModelFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<FactCheckFiltersInput>>>;
  book?: InputMaybe<BookFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  deletedAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  inputPrice?: InputMaybe<FloatFilterInput>;
  inputTokens?: InputMaybe<LongFilterInput>;
  isFactuallyCorrect?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<FactCheckFiltersInput>;
  ocrResult?: InputMaybe<StringFilterInput>;
  ocrText?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<FactCheckFiltersInput>>>;
  outputPrice?: InputMaybe<FloatFilterInput>;
  outputTokens?: InputMaybe<LongFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  reasoning?: InputMaybe<StringFilterInput>;
  section?: InputMaybe<SectionFiltersInput>;
  subSection?: InputMaybe<SubSectionFiltersInput>;
  totalPrice?: InputMaybe<FloatFilterInput>;
  totalTokens?: InputMaybe<LongFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  uuid?: InputMaybe<StringFilterInput>;
};

export type FactCheckInput = {
  aiModels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  book?: InputMaybe<Scalars['ID']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  inputPrice?: InputMaybe<Scalars['Float']['input']>;
  inputTokens?: InputMaybe<Scalars['Long']['input']>;
  isFactuallyCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  ocrResult?: InputMaybe<Scalars['String']['input']>;
  ocrText?: InputMaybe<Scalars['String']['input']>;
  outputPrice?: InputMaybe<Scalars['Float']['input']>;
  outputTokens?: InputMaybe<Scalars['Long']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reasoning?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['ID']['input']>;
  subSection?: InputMaybe<Scalars['ID']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  totalTokens?: InputMaybe<Scalars['Long']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type FactCheckRelationResponseCollection = {
  __typename?: 'FactCheckRelationResponseCollection';
  nodes: Array<FactCheck>;
};

export type Feedback = {
  __typename?: 'Feedback';
  categoryClientComments?: Maybe<Scalars['String']['output']>;
  categoryDownvote?: Maybe<Scalars['Boolean']['output']>;
  categoryUpvote?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  factClientComments?: Maybe<Scalars['String']['output']>;
  factDownvote?: Maybe<Scalars['Boolean']['output']>;
  factUpvote?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  religiousClientComments?: Maybe<Scalars['String']['output']>;
  religiousComparedReligions?: Maybe<Scalars['JSON']['output']>;
  religiousComparisonFrameDetected?: Maybe<Scalars['Boolean']['output']>;
  religiousDisrespectTowardsReligion?: Maybe<Scalars['Boolean']['output']>;
  religiousDisrespectTriggerList?: Maybe<Scalars['JSON']['output']>;
  religiousDisrespectedReligions?: Maybe<Scalars['JSON']['output']>;
  religiousDoctrineClaimType?: Maybe<Scalars['JSON']['output']>;
  religiousDownvote?: Maybe<Scalars['Boolean']['output']>;
  religiousDraftStanceByReligion?: Maybe<Scalars['JSON']['output']>;
  religiousExplicitOrImplicit?: Maybe<Scalars['JSON']['output']>;
  religiousFinalRating?: Maybe<Scalars['Int']['output']>;
  religiousFirstOrSecondPersonPronouns?: Maybe<Scalars['Boolean']['output']>;
  religiousFramingStrength?: Maybe<Scalars['JSON']['output']>;
  religiousHistoricSlurList?: Maybe<Scalars['JSON']['output']>;
  religiousHistoricSlursFound?: Maybe<Scalars['Boolean']['output']>;
  religiousKeywordList?: Maybe<Scalars['JSON']['output']>;
  religiousMetaphoricReligiousTermFound?: Maybe<Scalars['Boolean']['output']>;
  religiousMetaphoricReligiousTermList?: Maybe<Scalars['JSON']['output']>;
  religiousMiracleMentionedHow?: Maybe<Scalars['JSON']['output']>;
  religiousOverallBiasScore?: Maybe<Scalars['Int']['output']>;
  religiousRatingReason?: Maybe<Scalars['String']['output']>;
  religiousReasonNote?: Maybe<Scalars['String']['output']>;
  religiousReligionKeywordsFound?: Maybe<Scalars['Boolean']['output']>;
  religiousReligionsNamed?: Maybe<Scalars['JSON']['output']>;
  religiousReligiousSlangFound?: Maybe<Scalars['Boolean']['output']>;
  religiousReligiousSlangList?: Maybe<Scalars['JSON']['output']>;
  religiousTone?: Maybe<Scalars['JSON']['output']>;
  religiousToneConfidence?: Maybe<Scalars['Float']['output']>;
  religiousUpvote?: Maybe<Scalars['Boolean']['output']>;
  religiousWhoSaysIt?: Maybe<Scalars['JSON']['output']>;
  sexuallyAnatomicalTermsList?: Maybe<Scalars['JSON']['output']>;
  sexuallyAnatomicalTermsPresent?: Maybe<Scalars['Boolean']['output']>;
  sexuallyCharacterAge?: Maybe<Scalars['JSON']['output']>;
  sexuallyChromosomallyDefinedGender?: Maybe<Scalars['JSON']['output']>;
  sexuallyClientComments?: Maybe<Scalars['String']['output']>;
  sexuallyContainsDialogue?: Maybe<Scalars['Boolean']['output']>;
  sexuallyDownvote?: Maybe<Scalars['Boolean']['output']>;
  sexuallyEuphemismsList?: Maybe<Scalars['JSON']['output']>;
  sexuallyExcessiveFocusOnBodyDescription?: Maybe<Scalars['Boolean']['output']>;
  sexuallyExplicitTermsFound?: Maybe<Scalars['Boolean']['output']>;
  sexuallyExplicitTermsList?: Maybe<Scalars['JSON']['output']>;
  sexuallyFinalRating?: Maybe<Scalars['Int']['output']>;
  sexuallyFirstPersonPerspective?: Maybe<Scalars['Boolean']['output']>;
  sexuallyIntentDetected?: Maybe<Scalars['JSON']['output']>;
  sexuallyLanguageOfSecrecyOrConcealment?: Maybe<Scalars['Boolean']['output']>;
  sexuallyNudityDetected?: Maybe<Scalars['JSON']['output']>;
  sexuallyNudityExtent?: Maybe<Scalars['JSON']['output']>;
  sexuallyNudityType?: Maybe<Scalars['JSON']['output']>;
  sexuallyPhysicalContactType?: Maybe<Scalars['JSON']['output']>;
  sexuallyPowerImbalancePresent?: Maybe<Scalars['Boolean']['output']>;
  sexuallyRatingReason?: Maybe<Scalars['String']['output']>;
  sexuallyRoleplayOrFantasyContext?: Maybe<Scalars['Boolean']['output']>;
  sexuallySelfIdentifiedGenders?: Maybe<Scalars['JSON']['output']>;
  sexuallySetting?: Maybe<Scalars['JSON']['output']>;
  sexuallySexualActsDetected?: Maybe<Scalars['JSON']['output']>;
  sexuallySexualRelationshipType?: Maybe<Scalars['JSON']['output']>;
  sexuallySuggestivePhrasesList?: Maybe<Scalars['JSON']['output']>;
  sexuallyTone?: Maybe<Scalars['JSON']['output']>;
  sexuallyUpvote?: Maybe<Scalars['Boolean']['output']>;
  sexuallyViolenceOverlap?: Maybe<Scalars['Boolean']['output']>;
  subSection?: Maybe<SubSection>;
  suggestedCategory?: Maybe<Enum_Feedback_Suggestedcategory>;
  suggestedFactCheck?: Maybe<Scalars['String']['output']>;
  suggestedRating?: Maybe<Enum_Feedback_Suggestedrating>;
  suggestedReasoning?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<UsersPermissionsUser>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type FeedbackEntityResponseCollection = {
  __typename?: 'FeedbackEntityResponseCollection';
  nodes: Array<Feedback>;
  pageInfo: Pagination;
};

export type FeedbackFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FeedbackFiltersInput>>>;
  categoryClientComments?: InputMaybe<StringFilterInput>;
  categoryDownvote?: InputMaybe<BooleanFilterInput>;
  categoryUpvote?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  deletedAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  factClientComments?: InputMaybe<StringFilterInput>;
  factDownvote?: InputMaybe<BooleanFilterInput>;
  factUpvote?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<FeedbackFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<FeedbackFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  religiousClientComments?: InputMaybe<StringFilterInput>;
  religiousComparedReligions?: InputMaybe<JsonFilterInput>;
  religiousComparisonFrameDetected?: InputMaybe<BooleanFilterInput>;
  religiousDisrespectTowardsReligion?: InputMaybe<BooleanFilterInput>;
  religiousDisrespectTriggerList?: InputMaybe<JsonFilterInput>;
  religiousDisrespectedReligions?: InputMaybe<JsonFilterInput>;
  religiousDoctrineClaimType?: InputMaybe<JsonFilterInput>;
  religiousDownvote?: InputMaybe<BooleanFilterInput>;
  religiousDraftStanceByReligion?: InputMaybe<JsonFilterInput>;
  religiousExplicitOrImplicit?: InputMaybe<JsonFilterInput>;
  religiousFinalRating?: InputMaybe<IntFilterInput>;
  religiousFirstOrSecondPersonPronouns?: InputMaybe<BooleanFilterInput>;
  religiousFramingStrength?: InputMaybe<JsonFilterInput>;
  religiousHistoricSlurList?: InputMaybe<JsonFilterInput>;
  religiousHistoricSlursFound?: InputMaybe<BooleanFilterInput>;
  religiousKeywordList?: InputMaybe<JsonFilterInput>;
  religiousMetaphoricReligiousTermFound?: InputMaybe<BooleanFilterInput>;
  religiousMetaphoricReligiousTermList?: InputMaybe<JsonFilterInput>;
  religiousMiracleMentionedHow?: InputMaybe<JsonFilterInput>;
  religiousOverallBiasScore?: InputMaybe<IntFilterInput>;
  religiousRatingReason?: InputMaybe<StringFilterInput>;
  religiousReasonNote?: InputMaybe<StringFilterInput>;
  religiousReligionKeywordsFound?: InputMaybe<BooleanFilterInput>;
  religiousReligionsNamed?: InputMaybe<JsonFilterInput>;
  religiousReligiousSlangFound?: InputMaybe<BooleanFilterInput>;
  religiousReligiousSlangList?: InputMaybe<JsonFilterInput>;
  religiousTone?: InputMaybe<JsonFilterInput>;
  religiousToneConfidence?: InputMaybe<FloatFilterInput>;
  religiousUpvote?: InputMaybe<BooleanFilterInput>;
  religiousWhoSaysIt?: InputMaybe<JsonFilterInput>;
  sexuallyAnatomicalTermsList?: InputMaybe<JsonFilterInput>;
  sexuallyAnatomicalTermsPresent?: InputMaybe<BooleanFilterInput>;
  sexuallyCharacterAge?: InputMaybe<JsonFilterInput>;
  sexuallyChromosomallyDefinedGender?: InputMaybe<JsonFilterInput>;
  sexuallyClientComments?: InputMaybe<StringFilterInput>;
  sexuallyContainsDialogue?: InputMaybe<BooleanFilterInput>;
  sexuallyDownvote?: InputMaybe<BooleanFilterInput>;
  sexuallyEuphemismsList?: InputMaybe<JsonFilterInput>;
  sexuallyExcessiveFocusOnBodyDescription?: InputMaybe<BooleanFilterInput>;
  sexuallyExplicitTermsFound?: InputMaybe<BooleanFilterInput>;
  sexuallyExplicitTermsList?: InputMaybe<JsonFilterInput>;
  sexuallyFinalRating?: InputMaybe<IntFilterInput>;
  sexuallyFirstPersonPerspective?: InputMaybe<BooleanFilterInput>;
  sexuallyIntentDetected?: InputMaybe<JsonFilterInput>;
  sexuallyLanguageOfSecrecyOrConcealment?: InputMaybe<BooleanFilterInput>;
  sexuallyNudityDetected?: InputMaybe<JsonFilterInput>;
  sexuallyNudityExtent?: InputMaybe<JsonFilterInput>;
  sexuallyNudityType?: InputMaybe<JsonFilterInput>;
  sexuallyPhysicalContactType?: InputMaybe<JsonFilterInput>;
  sexuallyPowerImbalancePresent?: InputMaybe<BooleanFilterInput>;
  sexuallyRatingReason?: InputMaybe<StringFilterInput>;
  sexuallyRoleplayOrFantasyContext?: InputMaybe<BooleanFilterInput>;
  sexuallySelfIdentifiedGenders?: InputMaybe<JsonFilterInput>;
  sexuallySetting?: InputMaybe<JsonFilterInput>;
  sexuallySexualActsDetected?: InputMaybe<JsonFilterInput>;
  sexuallySexualRelationshipType?: InputMaybe<JsonFilterInput>;
  sexuallySuggestivePhrasesList?: InputMaybe<JsonFilterInput>;
  sexuallyTone?: InputMaybe<JsonFilterInput>;
  sexuallyUpvote?: InputMaybe<BooleanFilterInput>;
  sexuallyViolenceOverlap?: InputMaybe<BooleanFilterInput>;
  subSection?: InputMaybe<SubSectionFiltersInput>;
  suggestedCategory?: InputMaybe<StringFilterInput>;
  suggestedFactCheck?: InputMaybe<StringFilterInput>;
  suggestedRating?: InputMaybe<StringFilterInput>;
  suggestedReasoning?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  userId?: InputMaybe<UsersPermissionsUserFiltersInput>;
  uuid?: InputMaybe<StringFilterInput>;
};

export type FeedbackInput = {
  categoryClientComments?: InputMaybe<Scalars['String']['input']>;
  categoryDownvote?: InputMaybe<Scalars['Boolean']['input']>;
  categoryUpvote?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  factClientComments?: InputMaybe<Scalars['String']['input']>;
  factDownvote?: InputMaybe<Scalars['Boolean']['input']>;
  factUpvote?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  religiousClientComments?: InputMaybe<Scalars['String']['input']>;
  religiousComparedReligions?: InputMaybe<Scalars['JSON']['input']>;
  religiousComparisonFrameDetected?: InputMaybe<Scalars['Boolean']['input']>;
  religiousDisrespectTowardsReligion?: InputMaybe<Scalars['Boolean']['input']>;
  religiousDisrespectTriggerList?: InputMaybe<Scalars['JSON']['input']>;
  religiousDisrespectedReligions?: InputMaybe<Scalars['JSON']['input']>;
  religiousDoctrineClaimType?: InputMaybe<Scalars['JSON']['input']>;
  religiousDownvote?: InputMaybe<Scalars['Boolean']['input']>;
  religiousDraftStanceByReligion?: InputMaybe<Scalars['JSON']['input']>;
  religiousExplicitOrImplicit?: InputMaybe<Scalars['JSON']['input']>;
  religiousFinalRating?: InputMaybe<Scalars['Int']['input']>;
  religiousFirstOrSecondPersonPronouns?: InputMaybe<Scalars['Boolean']['input']>;
  religiousFramingStrength?: InputMaybe<Scalars['JSON']['input']>;
  religiousHistoricSlurList?: InputMaybe<Scalars['JSON']['input']>;
  religiousHistoricSlursFound?: InputMaybe<Scalars['Boolean']['input']>;
  religiousKeywordList?: InputMaybe<Scalars['JSON']['input']>;
  religiousMetaphoricReligiousTermFound?: InputMaybe<Scalars['Boolean']['input']>;
  religiousMetaphoricReligiousTermList?: InputMaybe<Scalars['JSON']['input']>;
  religiousMiracleMentionedHow?: InputMaybe<Scalars['JSON']['input']>;
  religiousOverallBiasScore?: InputMaybe<Scalars['Int']['input']>;
  religiousRatingReason?: InputMaybe<Scalars['String']['input']>;
  religiousReasonNote?: InputMaybe<Scalars['String']['input']>;
  religiousReligionKeywordsFound?: InputMaybe<Scalars['Boolean']['input']>;
  religiousReligionsNamed?: InputMaybe<Scalars['JSON']['input']>;
  religiousReligiousSlangFound?: InputMaybe<Scalars['Boolean']['input']>;
  religiousReligiousSlangList?: InputMaybe<Scalars['JSON']['input']>;
  religiousTone?: InputMaybe<Scalars['JSON']['input']>;
  religiousToneConfidence?: InputMaybe<Scalars['Float']['input']>;
  religiousUpvote?: InputMaybe<Scalars['Boolean']['input']>;
  religiousWhoSaysIt?: InputMaybe<Scalars['JSON']['input']>;
  sexuallyAnatomicalTermsList?: InputMaybe<Scalars['JSON']['input']>;
  sexuallyAnatomicalTermsPresent?: InputMaybe<Scalars['Boolean']['input']>;
  sexuallyCharacterAge?: InputMaybe<Scalars['JSON']['input']>;
  sexuallyChromosomallyDefinedGender?: InputMaybe<Scalars['JSON']['input']>;
  sexuallyClientComments?: InputMaybe<Scalars['String']['input']>;
  sexuallyContainsDialogue?: InputMaybe<Scalars['Boolean']['input']>;
  sexuallyDownvote?: InputMaybe<Scalars['Boolean']['input']>;
  sexuallyEuphemismsList?: InputMaybe<Scalars['JSON']['input']>;
  sexuallyExcessiveFocusOnBodyDescription?: InputMaybe<Scalars['Boolean']['input']>;
  sexuallyExplicitTermsFound?: InputMaybe<Scalars['Boolean']['input']>;
  sexuallyExplicitTermsList?: InputMaybe<Scalars['JSON']['input']>;
  sexuallyFinalRating?: InputMaybe<Scalars['Int']['input']>;
  sexuallyFirstPersonPerspective?: InputMaybe<Scalars['Boolean']['input']>;
  sexuallyIntentDetected?: InputMaybe<Scalars['JSON']['input']>;
  sexuallyLanguageOfSecrecyOrConcealment?: InputMaybe<Scalars['Boolean']['input']>;
  sexuallyNudityDetected?: InputMaybe<Scalars['JSON']['input']>;
  sexuallyNudityExtent?: InputMaybe<Scalars['JSON']['input']>;
  sexuallyNudityType?: InputMaybe<Scalars['JSON']['input']>;
  sexuallyPhysicalContactType?: InputMaybe<Scalars['JSON']['input']>;
  sexuallyPowerImbalancePresent?: InputMaybe<Scalars['Boolean']['input']>;
  sexuallyRatingReason?: InputMaybe<Scalars['String']['input']>;
  sexuallyRoleplayOrFantasyContext?: InputMaybe<Scalars['Boolean']['input']>;
  sexuallySelfIdentifiedGenders?: InputMaybe<Scalars['JSON']['input']>;
  sexuallySetting?: InputMaybe<Scalars['JSON']['input']>;
  sexuallySexualActsDetected?: InputMaybe<Scalars['JSON']['input']>;
  sexuallySexualRelationshipType?: InputMaybe<Scalars['JSON']['input']>;
  sexuallySuggestivePhrasesList?: InputMaybe<Scalars['JSON']['input']>;
  sexuallyTone?: InputMaybe<Scalars['JSON']['input']>;
  sexuallyUpvote?: InputMaybe<Scalars['Boolean']['input']>;
  sexuallyViolenceOverlap?: InputMaybe<Scalars['Boolean']['input']>;
  subSection?: InputMaybe<Scalars['ID']['input']>;
  suggestedCategory?: InputMaybe<Enum_Feedback_Suggestedcategory>;
  suggestedFactCheck?: InputMaybe<Scalars['String']['input']>;
  suggestedRating?: InputMaybe<Enum_Feedback_Suggestedrating>;
  suggestedReasoning?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackRelationResponseCollection = {
  __typename?: 'FeedbackRelationResponseCollection';
  nodes: Array<Feedback>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type GenericMorph = AccessToken | AiModel | Asset | Book | CategoryAnalysis | FactCheck | Feedback | I18NLocale | ReligiousTransparency | ReviewWorkflowsWorkflow | ReviewWorkflowsWorkflowStage | Section | SexuallyInappropriate | SubSection | UploadFile | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type GetCategoryAnalysisCounts = {
  __typename?: 'GetCategoryAnalysisCounts';
  bookId?: Maybe<Scalars['String']['output']>;
  priceCounts?: Maybe<Scalars['Float']['output']>;
  tokenCounts?: Maybe<Scalars['Int']['output']>;
};

export type GetCategoryAnalysisCountsResponse = {
  __typename?: 'GetCategoryAnalysisCountsResponse';
  data?: Maybe<Array<Maybe<GetCategoryAnalysisCounts>>>;
};

export type GetFactCheckCounts = {
  __typename?: 'GetFactCheckCounts';
  bookId?: Maybe<Scalars['String']['output']>;
  priceCounts?: Maybe<Scalars['Float']['output']>;
  tokenCounts?: Maybe<Scalars['Int']['output']>;
};

export type GetFactCheckCountsResponse = {
  __typename?: 'GetFactCheckCountsResponse';
  data?: Maybe<Array<Maybe<GetFactCheckCounts>>>;
};

export type GetReligiousTransparencyCounts = {
  __typename?: 'GetReligiousTransparencyCounts';
  bookId?: Maybe<Scalars['String']['output']>;
  priceCounts?: Maybe<Scalars['Float']['output']>;
  tokenCounts?: Maybe<Scalars['Int']['output']>;
};

export type GetReligiousTransparencyCountsResponse = {
  __typename?: 'GetReligiousTransparencyCountsResponse';
  data?: Maybe<Array<Maybe<GetReligiousTransparencyCounts>>>;
};

export type GetSexuallyInappropriateCounts = {
  __typename?: 'GetSexuallyInappropriateCounts';
  bookId?: Maybe<Scalars['String']['output']>;
  priceCounts?: Maybe<Scalars['Float']['output']>;
  tokenCounts?: Maybe<Scalars['Int']['output']>;
};

export type GetSexuallyInappropriateCountsResponse = {
  __typename?: 'GetSexuallyInappropriateCountsResponse';
  data?: Maybe<Array<Maybe<GetSexuallyInappropriateCounts>>>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  nodes: Array<I18NLocale>;
  pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type LongFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  contains?: InputMaybe<Scalars['Long']['input']>;
  containsi?: InputMaybe<Scalars['Long']['input']>;
  endsWith?: InputMaybe<Scalars['Long']['input']>;
  eq?: InputMaybe<Scalars['Long']['input']>;
  eqi?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  ne?: InputMaybe<Scalars['Long']['input']>;
  nei?: InputMaybe<Scalars['Long']['input']>;
  not?: InputMaybe<LongFilterInput>;
  notContains?: InputMaybe<Scalars['Long']['input']>;
  notContainsi?: InputMaybe<Scalars['Long']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  startsWith?: InputMaybe<Scalars['Long']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createAccessToken?: Maybe<AccessToken>;
  createAiModel?: Maybe<AiModel>;
  createAsset?: Maybe<Asset>;
  createBook?: Maybe<Book>;
  createCategoryAnalysis?: Maybe<CategoryAnalysis>;
  createFactCheck?: Maybe<FactCheck>;
  createFeedback?: Maybe<Feedback>;
  createReligiousTransparency?: Maybe<ReligiousTransparency>;
  createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  createSection?: Maybe<Section>;
  createSexuallyInappropriate?: Maybe<SexuallyInappropriate>;
  createSubSection?: Maybe<SubSection>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteAccessToken?: Maybe<DeleteMutationResponse>;
  deleteAiModel?: Maybe<DeleteMutationResponse>;
  deleteAsset?: Maybe<DeleteMutationResponse>;
  deleteBook?: Maybe<DeleteMutationResponse>;
  deleteCategoryAnalysis?: Maybe<DeleteMutationResponse>;
  deleteFactCheck?: Maybe<DeleteMutationResponse>;
  deleteFeedback?: Maybe<DeleteMutationResponse>;
  deleteReligiousTransparency?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
  deleteSection?: Maybe<DeleteMutationResponse>;
  deleteSexuallyInappropriate?: Maybe<DeleteMutationResponse>;
  deleteSubSection?: Maybe<DeleteMutationResponse>;
  deleteUploadFile?: Maybe<UploadFile>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateAccessToken?: Maybe<AccessToken>;
  updateAiModel?: Maybe<AiModel>;
  updateAsset?: Maybe<Asset>;
  updateBook?: Maybe<Book>;
  updateCategoryAnalysis?: Maybe<CategoryAnalysis>;
  updateFactCheck?: Maybe<FactCheck>;
  updateFeedback?: Maybe<Feedback>;
  updateReligiousTransparency?: Maybe<ReligiousTransparency>;
  updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updateSection?: Maybe<Section>;
  updateSexuallyInappropriate?: Maybe<SexuallyInappropriate>;
  updateSubSection?: Maybe<SubSection>;
  updateUploadFile: UploadFile;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateAccessTokenArgs = {
  data: AccessTokenInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateAiModelArgs = {
  data: AiModelInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateAssetArgs = {
  data: AssetInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateBookArgs = {
  data: BookInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCategoryAnalysisArgs = {
  data: CategoryAnalysisInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateFactCheckArgs = {
  data: FactCheckInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateFeedbackArgs = {
  data: FeedbackInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReligiousTransparencyArgs = {
  data: ReligiousTransparencyInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateSectionArgs = {
  data: SectionInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateSexuallyInappropriateArgs = {
  data: SexuallyInappropriateInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateSubSectionArgs = {
  data: SubSectionInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteAccessTokenArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteAiModelArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteAssetArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteBookArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCategoryAnalysisArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteFactCheckArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteFeedbackArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReligiousTransparencyArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteSectionArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteSexuallyInappropriateArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteSubSectionArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUpdateAccessTokenArgs = {
  data: AccessTokenInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateAiModelArgs = {
  data: AiModelInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateAssetArgs = {
  data: AssetInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateBookArgs = {
  data: BookInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCategoryAnalysisArgs = {
  data: CategoryAnalysisInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateFactCheckArgs = {
  data: FactCheckInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateFeedbackArgs = {
  data: FeedbackInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReligiousTransparencyArgs = {
  data: ReligiousTransparencyInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSectionArgs = {
  data: SectionInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSexuallyInappropriateArgs = {
  data: SexuallyInappropriateInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSubSectionArgs = {
  data: SubSectionInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export enum PublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type Query = {
  __typename?: 'Query';
  accessToken?: Maybe<AccessToken>;
  accessTokens: Array<Maybe<AccessToken>>;
  accessTokens_connection?: Maybe<AccessTokenEntityResponseCollection>;
  aiModel?: Maybe<AiModel>;
  aiModels: Array<Maybe<AiModel>>;
  aiModels_connection?: Maybe<AiModelEntityResponseCollection>;
  asset?: Maybe<Asset>;
  assets: Array<Maybe<Asset>>;
  assets_connection?: Maybe<AssetEntityResponseCollection>;
  book?: Maybe<Book>;
  books: Array<Maybe<Book>>;
  books_connection?: Maybe<BookEntityResponseCollection>;
  categoryAnalyses: Array<Maybe<CategoryAnalysis>>;
  categoryAnalyses_connection?: Maybe<CategoryAnalysisEntityResponseCollection>;
  categoryAnalysis?: Maybe<CategoryAnalysis>;
  factCheck?: Maybe<FactCheck>;
  factChecks: Array<Maybe<FactCheck>>;
  factChecks_connection?: Maybe<FactCheckEntityResponseCollection>;
  feedback?: Maybe<Feedback>;
  feedbacks: Array<Maybe<Feedback>>;
  feedbacks_connection?: Maybe<FeedbackEntityResponseCollection>;
  getCategoryAnalysisTotals?: Maybe<GetCategoryAnalysisCountsResponse>;
  getFactCheckTotals?: Maybe<GetFactCheckCountsResponse>;
  getReligiousTransparencyTotals?: Maybe<GetReligiousTransparencyCountsResponse>;
  getSexuallyInappropriateTotals?: Maybe<GetSexuallyInappropriateCountsResponse>;
  i18NLocale?: Maybe<I18NLocale>;
  i18NLocales: Array<Maybe<I18NLocale>>;
  i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  religiousTransparencies: Array<Maybe<ReligiousTransparency>>;
  religiousTransparencies_connection?: Maybe<ReligiousTransparencyEntityResponseCollection>;
  religiousTransparency?: Maybe<ReligiousTransparency>;
  reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
  reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
  reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
  section?: Maybe<Section>;
  sectionTypes?: Maybe<SectionTypesResponse>;
  sections: Array<Maybe<Section>>;
  sections_connection?: Maybe<SectionEntityResponseCollection>;
  sexuallyInappropriate?: Maybe<SexuallyInappropriate>;
  sexuallyInappropriates: Array<Maybe<SexuallyInappropriate>>;
  sexuallyInappropriates_connection?: Maybe<SexuallyInappropriateEntityResponseCollection>;
  subSection?: Maybe<SubSection>;
  subSectionTypes?: Maybe<SubSectionTypesResponse>;
  subSections: Array<Maybe<SubSection>>;
  subSections_connection?: Maybe<SubSectionEntityResponseCollection>;
  uploadFile?: Maybe<UploadFile>;
  uploadFiles: Array<Maybe<UploadFile>>;
  uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRole>;
  usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
  usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUser>;
  usersPermissionsUsers: Array<Maybe<UsersPermissionsUser>>;
  usersPermissionsUsers_connection?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};


export type QueryAccessTokenArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAccessTokensArgs = {
  filters?: InputMaybe<AccessTokenFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAccessTokens_ConnectionArgs = {
  filters?: InputMaybe<AccessTokenFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAiModelArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAiModelsArgs = {
  filters?: InputMaybe<AiModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAiModels_ConnectionArgs = {
  filters?: InputMaybe<AiModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAssetArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAssetsArgs = {
  filters?: InputMaybe<AssetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAssets_ConnectionArgs = {
  filters?: InputMaybe<AssetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryBookArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryBooksArgs = {
  filters?: InputMaybe<BookFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryBooks_ConnectionArgs = {
  filters?: InputMaybe<BookFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCategoryAnalysesArgs = {
  filters?: InputMaybe<CategoryAnalysisFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCategoryAnalyses_ConnectionArgs = {
  filters?: InputMaybe<CategoryAnalysisFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCategoryAnalysisArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryFactCheckArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryFactChecksArgs = {
  filters?: InputMaybe<FactCheckFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryFactChecks_ConnectionArgs = {
  filters?: InputMaybe<FactCheckFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryFeedbackArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryFeedbacksArgs = {
  filters?: InputMaybe<FeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryFeedbacks_ConnectionArgs = {
  filters?: InputMaybe<FeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocaleArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocales_ConnectionArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReligiousTransparenciesArgs = {
  filters?: InputMaybe<ReligiousTransparencyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReligiousTransparencies_ConnectionArgs = {
  filters?: InputMaybe<ReligiousTransparencyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReligiousTransparencyArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowsArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySectionArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySectionTypesArgs = {
  filters?: InputMaybe<SectionTypeFilters>;
};


export type QuerySectionsArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySections_ConnectionArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySexuallyInappropriateArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySexuallyInappropriatesArgs = {
  filters?: InputMaybe<SexuallyInappropriateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySexuallyInappropriates_ConnectionArgs = {
  filters?: InputMaybe<SexuallyInappropriateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubSectionArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubSectionsArgs = {
  filters?: InputMaybe<SubSectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubSections_ConnectionArgs = {
  filters?: InputMaybe<SubSectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFileArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFiles_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoleArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUserArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type ReligiousTransparency = {
  __typename?: 'ReligiousTransparency';
  aiModels: Array<Maybe<AiModel>>;
  aiModels_connection?: Maybe<AiModelRelationResponseCollection>;
  aiStages?: Maybe<Scalars['JSON']['output']>;
  book?: Maybe<Book>;
  comparedReligions?: Maybe<Scalars['JSON']['output']>;
  comparisonFrameDetected?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disrespectTowardsReligion?: Maybe<Scalars['Boolean']['output']>;
  disrespectTriggerList?: Maybe<Scalars['JSON']['output']>;
  disrespectedReligions?: Maybe<Scalars['JSON']['output']>;
  doctrineClaimType?: Maybe<Scalars['JSON']['output']>;
  documentId: Scalars['ID']['output'];
  draftStanceByReligion?: Maybe<Scalars['JSON']['output']>;
  explicitOrImplicit?: Maybe<Scalars['JSON']['output']>;
  firstOrSecondPersonPronouns?: Maybe<Scalars['Boolean']['output']>;
  framingStrength?: Maybe<Scalars['JSON']['output']>;
  historicSlurList?: Maybe<Scalars['JSON']['output']>;
  historicSlursFound?: Maybe<Scalars['Boolean']['output']>;
  inputPrice?: Maybe<Scalars['Float']['output']>;
  inputTokens?: Maybe<Scalars['Long']['output']>;
  keywordList?: Maybe<Scalars['JSON']['output']>;
  metaphoricReligiousTermFound?: Maybe<Scalars['Boolean']['output']>;
  metaphoricReligiousTermList?: Maybe<Scalars['JSON']['output']>;
  miracleMentionedHow?: Maybe<Scalars['JSON']['output']>;
  outputPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Long']['output']>;
  overallBiasScore?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reasonNote?: Maybe<Scalars['String']['output']>;
  religionKeywordsFound?: Maybe<Scalars['Boolean']['output']>;
  religionsNamed?: Maybe<Scalars['JSON']['output']>;
  religiousSlangFound?: Maybe<Scalars['Boolean']['output']>;
  religiousSlangList?: Maybe<Scalars['JSON']['output']>;
  section?: Maybe<Section>;
  subSection?: Maybe<SubSection>;
  tone?: Maybe<Scalars['JSON']['output']>;
  toneConfidence?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Long']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  whoSaysIt?: Maybe<Scalars['JSON']['output']>;
};


export type ReligiousTransparencyAiModelsArgs = {
  filters?: InputMaybe<AiModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ReligiousTransparencyAiModels_ConnectionArgs = {
  filters?: InputMaybe<AiModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReligiousTransparencyEntityResponseCollection = {
  __typename?: 'ReligiousTransparencyEntityResponseCollection';
  nodes: Array<ReligiousTransparency>;
  pageInfo: Pagination;
};

export type ReligiousTransparencyFiltersInput = {
  aiModels?: InputMaybe<AiModelFiltersInput>;
  aiStages?: InputMaybe<JsonFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ReligiousTransparencyFiltersInput>>>;
  book?: InputMaybe<BookFiltersInput>;
  comparedReligions?: InputMaybe<JsonFilterInput>;
  comparisonFrameDetected?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  disrespectTowardsReligion?: InputMaybe<BooleanFilterInput>;
  disrespectTriggerList?: InputMaybe<JsonFilterInput>;
  disrespectedReligions?: InputMaybe<JsonFilterInput>;
  doctrineClaimType?: InputMaybe<JsonFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  draftStanceByReligion?: InputMaybe<JsonFilterInput>;
  explicitOrImplicit?: InputMaybe<JsonFilterInput>;
  firstOrSecondPersonPronouns?: InputMaybe<BooleanFilterInput>;
  framingStrength?: InputMaybe<JsonFilterInput>;
  historicSlurList?: InputMaybe<JsonFilterInput>;
  historicSlursFound?: InputMaybe<BooleanFilterInput>;
  inputPrice?: InputMaybe<FloatFilterInput>;
  inputTokens?: InputMaybe<LongFilterInput>;
  keywordList?: InputMaybe<JsonFilterInput>;
  metaphoricReligiousTermFound?: InputMaybe<BooleanFilterInput>;
  metaphoricReligiousTermList?: InputMaybe<JsonFilterInput>;
  miracleMentionedHow?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<ReligiousTransparencyFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReligiousTransparencyFiltersInput>>>;
  outputPrice?: InputMaybe<FloatFilterInput>;
  outputTokens?: InputMaybe<LongFilterInput>;
  overallBiasScore?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  reasonNote?: InputMaybe<StringFilterInput>;
  religionKeywordsFound?: InputMaybe<BooleanFilterInput>;
  religionsNamed?: InputMaybe<JsonFilterInput>;
  religiousSlangFound?: InputMaybe<BooleanFilterInput>;
  religiousSlangList?: InputMaybe<JsonFilterInput>;
  section?: InputMaybe<SectionFiltersInput>;
  subSection?: InputMaybe<SubSectionFiltersInput>;
  tone?: InputMaybe<JsonFilterInput>;
  toneConfidence?: InputMaybe<FloatFilterInput>;
  totalPrice?: InputMaybe<FloatFilterInput>;
  totalTokens?: InputMaybe<LongFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  whoSaysIt?: InputMaybe<JsonFilterInput>;
};

export type ReligiousTransparencyInput = {
  aiModels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  aiStages?: InputMaybe<Scalars['JSON']['input']>;
  book?: InputMaybe<Scalars['ID']['input']>;
  comparedReligions?: InputMaybe<Scalars['JSON']['input']>;
  comparisonFrameDetected?: InputMaybe<Scalars['Boolean']['input']>;
  disrespectTowardsReligion?: InputMaybe<Scalars['Boolean']['input']>;
  disrespectTriggerList?: InputMaybe<Scalars['JSON']['input']>;
  disrespectedReligions?: InputMaybe<Scalars['JSON']['input']>;
  doctrineClaimType?: InputMaybe<Scalars['JSON']['input']>;
  draftStanceByReligion?: InputMaybe<Scalars['JSON']['input']>;
  explicitOrImplicit?: InputMaybe<Scalars['JSON']['input']>;
  firstOrSecondPersonPronouns?: InputMaybe<Scalars['Boolean']['input']>;
  framingStrength?: InputMaybe<Scalars['JSON']['input']>;
  historicSlurList?: InputMaybe<Scalars['JSON']['input']>;
  historicSlursFound?: InputMaybe<Scalars['Boolean']['input']>;
  inputPrice?: InputMaybe<Scalars['Float']['input']>;
  inputTokens?: InputMaybe<Scalars['Long']['input']>;
  keywordList?: InputMaybe<Scalars['JSON']['input']>;
  metaphoricReligiousTermFound?: InputMaybe<Scalars['Boolean']['input']>;
  metaphoricReligiousTermList?: InputMaybe<Scalars['JSON']['input']>;
  miracleMentionedHow?: InputMaybe<Scalars['JSON']['input']>;
  outputPrice?: InputMaybe<Scalars['Float']['input']>;
  outputTokens?: InputMaybe<Scalars['Long']['input']>;
  overallBiasScore?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reasonNote?: InputMaybe<Scalars['String']['input']>;
  religionKeywordsFound?: InputMaybe<Scalars['Boolean']['input']>;
  religionsNamed?: InputMaybe<Scalars['JSON']['input']>;
  religiousSlangFound?: InputMaybe<Scalars['Boolean']['input']>;
  religiousSlangList?: InputMaybe<Scalars['JSON']['input']>;
  section?: InputMaybe<Scalars['ID']['input']>;
  subSection?: InputMaybe<Scalars['ID']['input']>;
  tone?: InputMaybe<Scalars['JSON']['input']>;
  toneConfidence?: InputMaybe<Scalars['Float']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  totalTokens?: InputMaybe<Scalars['Long']['input']>;
  whoSaysIt?: InputMaybe<Scalars['JSON']['input']>;
};

export type ReligiousTransparencyRelationResponseCollection = {
  __typename?: 'ReligiousTransparencyRelationResponseCollection';
  nodes: Array<ReligiousTransparency>;
};

export type ReviewWorkflowsWorkflow = {
  __typename?: 'ReviewWorkflowsWorkflow';
  contentTypes: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
  stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflow>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  contentTypes?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  stageRequiredToPublish?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  stages?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReviewWorkflowsWorkflowInput = {
  contentTypes?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stageRequiredToPublish?: InputMaybe<Scalars['ID']['input']>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ReviewWorkflowsWorkflowStage = {
  __typename?: 'ReviewWorkflowsWorkflowStage';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workflow?: Maybe<ReviewWorkflowsWorkflow>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workflow?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workflow?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageRelationResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type Section = {
  __typename?: 'Section';
  assets: Array<Maybe<Asset>>;
  assets_connection?: Maybe<AssetRelationResponseCollection>;
  book?: Maybe<Book>;
  categoryAnalyses: Array<Maybe<CategoryAnalysis>>;
  categoryAnalyses_connection?: Maybe<CategoryAnalysisRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  factChecks: Array<Maybe<FactCheck>>;
  factChecks_connection?: Maybe<FactCheckRelationResponseCollection>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  priceCounts?: Maybe<Scalars['Float']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  religiousTransparencies: Array<Maybe<ReligiousTransparency>>;
  religiousTransparencies_connection?: Maybe<ReligiousTransparencyRelationResponseCollection>;
  sexuallyInappropriates: Array<Maybe<SexuallyInappropriate>>;
  sexuallyInappropriates_connection?: Maybe<SexuallyInappropriateRelationResponseCollection>;
  subSections: Array<Maybe<SubSection>>;
  subSections_connection?: Maybe<SubSectionRelationResponseCollection>;
  title?: Maybe<Scalars['String']['output']>;
  tokenCounts?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};


export type SectionAssetsArgs = {
  filters?: InputMaybe<AssetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SectionAssets_ConnectionArgs = {
  filters?: InputMaybe<AssetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SectionCategoryAnalysesArgs = {
  filters?: InputMaybe<CategoryAnalysisFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SectionCategoryAnalyses_ConnectionArgs = {
  filters?: InputMaybe<CategoryAnalysisFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SectionFactChecksArgs = {
  filters?: InputMaybe<FactCheckFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SectionFactChecks_ConnectionArgs = {
  filters?: InputMaybe<FactCheckFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SectionReligiousTransparenciesArgs = {
  filters?: InputMaybe<ReligiousTransparencyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SectionReligiousTransparencies_ConnectionArgs = {
  filters?: InputMaybe<ReligiousTransparencyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SectionSexuallyInappropriatesArgs = {
  filters?: InputMaybe<SexuallyInappropriateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SectionSexuallyInappropriates_ConnectionArgs = {
  filters?: InputMaybe<SexuallyInappropriateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SectionSubSectionsArgs = {
  filters?: InputMaybe<SubSectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SectionSubSections_ConnectionArgs = {
  filters?: InputMaybe<SubSectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SectionEntityResponseCollection = {
  __typename?: 'SectionEntityResponseCollection';
  nodes: Array<Section>;
  pageInfo: Pagination;
};

export type SectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SectionFiltersInput>>>;
  assets?: InputMaybe<AssetFiltersInput>;
  book?: InputMaybe<BookFiltersInput>;
  categoryAnalyses?: InputMaybe<CategoryAnalysisFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  deletedAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  factChecks?: InputMaybe<FactCheckFiltersInput>;
  metadata?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<SectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SectionFiltersInput>>>;
  pageNumber?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  religiousTransparencies?: InputMaybe<ReligiousTransparencyFiltersInput>;
  sexuallyInappropriates?: InputMaybe<SexuallyInappropriateFiltersInput>;
  subSections?: InputMaybe<SubSectionFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  uuid?: InputMaybe<StringFilterInput>;
};

export type SectionInput = {
  assets?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  book?: InputMaybe<Scalars['ID']['input']>;
  categoryAnalyses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  factChecks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  religiousTransparencies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sexuallyInappropriates?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subSections?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type SectionRelationResponseCollection = {
  __typename?: 'SectionRelationResponseCollection';
  nodes: Array<Section>;
};

export type SectionTypeFilters = {
  bookId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SectionTypesResponse = {
  __typename?: 'SectionTypesResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SexuallyInappropriate = {
  __typename?: 'SexuallyInappropriate';
  aiModels: Array<Maybe<AiModel>>;
  aiModels_connection?: Maybe<AiModelRelationResponseCollection>;
  aiStages?: Maybe<Scalars['JSON']['output']>;
  anatomicalTermsList?: Maybe<Scalars['JSON']['output']>;
  anatomicalTermsPresent?: Maybe<Scalars['Boolean']['output']>;
  book?: Maybe<Book>;
  characterAge?: Maybe<Scalars['JSON']['output']>;
  chromosomallyDefinedGender?: Maybe<Scalars['JSON']['output']>;
  containsDialogue?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  euphemismsList?: Maybe<Scalars['JSON']['output']>;
  excessiveFocusOnBodyDescription?: Maybe<Scalars['Boolean']['output']>;
  explicitTermsFound?: Maybe<Scalars['Boolean']['output']>;
  explicitTermsList?: Maybe<Scalars['JSON']['output']>;
  finalRating?: Maybe<Scalars['Int']['output']>;
  firstPersonPerspective?: Maybe<Scalars['Boolean']['output']>;
  inputPrice?: Maybe<Scalars['Float']['output']>;
  inputTokens?: Maybe<Scalars['Long']['output']>;
  intentDetected?: Maybe<Scalars['JSON']['output']>;
  languageOfSecrecyOrConcealment?: Maybe<Scalars['Boolean']['output']>;
  nudityDetected?: Maybe<Scalars['JSON']['output']>;
  nudityExtent?: Maybe<Scalars['JSON']['output']>;
  nudityType?: Maybe<Scalars['JSON']['output']>;
  outputPrice?: Maybe<Scalars['Float']['output']>;
  outputTokens?: Maybe<Scalars['Long']['output']>;
  physicalContactType?: Maybe<Scalars['JSON']['output']>;
  powerImbalancePresent?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  ratingReason?: Maybe<Scalars['String']['output']>;
  roleplayOrFantasyContext?: Maybe<Scalars['Boolean']['output']>;
  section?: Maybe<Section>;
  selfIdentifiedGenders?: Maybe<Scalars['JSON']['output']>;
  setting?: Maybe<Scalars['JSON']['output']>;
  sexualActsDetected?: Maybe<Scalars['JSON']['output']>;
  sexualRelationshipType?: Maybe<Scalars['JSON']['output']>;
  subSection?: Maybe<SubSection>;
  suggestivePhrasesList?: Maybe<Scalars['JSON']['output']>;
  tone?: Maybe<Scalars['JSON']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  totalTokens?: Maybe<Scalars['Long']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  violenceOverlap?: Maybe<Scalars['Boolean']['output']>;
};


export type SexuallyInappropriateAiModelsArgs = {
  filters?: InputMaybe<AiModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SexuallyInappropriateAiModels_ConnectionArgs = {
  filters?: InputMaybe<AiModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SexuallyInappropriateEntityResponseCollection = {
  __typename?: 'SexuallyInappropriateEntityResponseCollection';
  nodes: Array<SexuallyInappropriate>;
  pageInfo: Pagination;
};

export type SexuallyInappropriateFiltersInput = {
  aiModels?: InputMaybe<AiModelFiltersInput>;
  aiStages?: InputMaybe<JsonFilterInput>;
  anatomicalTermsList?: InputMaybe<JsonFilterInput>;
  anatomicalTermsPresent?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SexuallyInappropriateFiltersInput>>>;
  book?: InputMaybe<BookFiltersInput>;
  characterAge?: InputMaybe<JsonFilterInput>;
  chromosomallyDefinedGender?: InputMaybe<JsonFilterInput>;
  containsDialogue?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  euphemismsList?: InputMaybe<JsonFilterInput>;
  excessiveFocusOnBodyDescription?: InputMaybe<BooleanFilterInput>;
  explicitTermsFound?: InputMaybe<BooleanFilterInput>;
  explicitTermsList?: InputMaybe<JsonFilterInput>;
  finalRating?: InputMaybe<IntFilterInput>;
  firstPersonPerspective?: InputMaybe<BooleanFilterInput>;
  inputPrice?: InputMaybe<FloatFilterInput>;
  inputTokens?: InputMaybe<LongFilterInput>;
  intentDetected?: InputMaybe<JsonFilterInput>;
  languageOfSecrecyOrConcealment?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<SexuallyInappropriateFiltersInput>;
  nudityDetected?: InputMaybe<JsonFilterInput>;
  nudityExtent?: InputMaybe<JsonFilterInput>;
  nudityType?: InputMaybe<JsonFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SexuallyInappropriateFiltersInput>>>;
  outputPrice?: InputMaybe<FloatFilterInput>;
  outputTokens?: InputMaybe<LongFilterInput>;
  physicalContactType?: InputMaybe<JsonFilterInput>;
  powerImbalancePresent?: InputMaybe<BooleanFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  ratingReason?: InputMaybe<StringFilterInput>;
  roleplayOrFantasyContext?: InputMaybe<BooleanFilterInput>;
  section?: InputMaybe<SectionFiltersInput>;
  selfIdentifiedGenders?: InputMaybe<JsonFilterInput>;
  setting?: InputMaybe<JsonFilterInput>;
  sexualActsDetected?: InputMaybe<JsonFilterInput>;
  sexualRelationshipType?: InputMaybe<JsonFilterInput>;
  subSection?: InputMaybe<SubSectionFiltersInput>;
  suggestivePhrasesList?: InputMaybe<JsonFilterInput>;
  tone?: InputMaybe<JsonFilterInput>;
  totalPrice?: InputMaybe<FloatFilterInput>;
  totalTokens?: InputMaybe<LongFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  violenceOverlap?: InputMaybe<BooleanFilterInput>;
};

export type SexuallyInappropriateInput = {
  aiModels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  aiStages?: InputMaybe<Scalars['JSON']['input']>;
  anatomicalTermsList?: InputMaybe<Scalars['JSON']['input']>;
  anatomicalTermsPresent?: InputMaybe<Scalars['Boolean']['input']>;
  book?: InputMaybe<Scalars['ID']['input']>;
  characterAge?: InputMaybe<Scalars['JSON']['input']>;
  chromosomallyDefinedGender?: InputMaybe<Scalars['JSON']['input']>;
  containsDialogue?: InputMaybe<Scalars['Boolean']['input']>;
  euphemismsList?: InputMaybe<Scalars['JSON']['input']>;
  excessiveFocusOnBodyDescription?: InputMaybe<Scalars['Boolean']['input']>;
  explicitTermsFound?: InputMaybe<Scalars['Boolean']['input']>;
  explicitTermsList?: InputMaybe<Scalars['JSON']['input']>;
  finalRating?: InputMaybe<Scalars['Int']['input']>;
  firstPersonPerspective?: InputMaybe<Scalars['Boolean']['input']>;
  inputPrice?: InputMaybe<Scalars['Float']['input']>;
  inputTokens?: InputMaybe<Scalars['Long']['input']>;
  intentDetected?: InputMaybe<Scalars['JSON']['input']>;
  languageOfSecrecyOrConcealment?: InputMaybe<Scalars['Boolean']['input']>;
  nudityDetected?: InputMaybe<Scalars['JSON']['input']>;
  nudityExtent?: InputMaybe<Scalars['JSON']['input']>;
  nudityType?: InputMaybe<Scalars['JSON']['input']>;
  outputPrice?: InputMaybe<Scalars['Float']['input']>;
  outputTokens?: InputMaybe<Scalars['Long']['input']>;
  physicalContactType?: InputMaybe<Scalars['JSON']['input']>;
  powerImbalancePresent?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ratingReason?: InputMaybe<Scalars['String']['input']>;
  roleplayOrFantasyContext?: InputMaybe<Scalars['Boolean']['input']>;
  section?: InputMaybe<Scalars['ID']['input']>;
  selfIdentifiedGenders?: InputMaybe<Scalars['JSON']['input']>;
  setting?: InputMaybe<Scalars['JSON']['input']>;
  sexualActsDetected?: InputMaybe<Scalars['JSON']['input']>;
  sexualRelationshipType?: InputMaybe<Scalars['JSON']['input']>;
  subSection?: InputMaybe<Scalars['ID']['input']>;
  suggestivePhrasesList?: InputMaybe<Scalars['JSON']['input']>;
  tone?: InputMaybe<Scalars['JSON']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  totalTokens?: InputMaybe<Scalars['Long']['input']>;
  violenceOverlap?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SexuallyInappropriateRelationResponseCollection = {
  __typename?: 'SexuallyInappropriateRelationResponseCollection';
  nodes: Array<SexuallyInappropriate>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubSection = {
  __typename?: 'SubSection';
  asset?: Maybe<Asset>;
  book?: Maybe<Book>;
  categoryAnalysis?: Maybe<CategoryAnalysis>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  factCheck?: Maybe<FactCheck>;
  feedback?: Maybe<Feedback>;
  isProcessed?: Maybe<Scalars['Boolean']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  paragraph?: Maybe<Scalars['String']['output']>;
  paragraphNumber?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  religiousTransparency?: Maybe<ReligiousTransparency>;
  section?: Maybe<Section>;
  sexuallyInappropriate?: Maybe<SexuallyInappropriate>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type SubSectionEntityResponseCollection = {
  __typename?: 'SubSectionEntityResponseCollection';
  nodes: Array<SubSection>;
  pageInfo: Pagination;
};

export type SubSectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubSectionFiltersInput>>>;
  asset?: InputMaybe<AssetFiltersInput>;
  book?: InputMaybe<BookFiltersInput>;
  categoryAnalysis?: InputMaybe<CategoryAnalysisFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  deletedAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  factCheck?: InputMaybe<FactCheckFiltersInput>;
  feedback?: InputMaybe<FeedbackFiltersInput>;
  isProcessed?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<SubSectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubSectionFiltersInput>>>;
  pageNumber?: InputMaybe<IntFilterInput>;
  paragraph?: InputMaybe<StringFilterInput>;
  paragraphNumber?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  religiousTransparency?: InputMaybe<ReligiousTransparencyFiltersInput>;
  section?: InputMaybe<SectionFiltersInput>;
  sexuallyInappropriate?: InputMaybe<SexuallyInappropriateFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  uuid?: InputMaybe<StringFilterInput>;
};

export type SubSectionInput = {
  asset?: InputMaybe<Scalars['ID']['input']>;
  book?: InputMaybe<Scalars['ID']['input']>;
  categoryAnalysis?: InputMaybe<Scalars['ID']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  factCheck?: InputMaybe<Scalars['ID']['input']>;
  feedback?: InputMaybe<Scalars['ID']['input']>;
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paragraph?: InputMaybe<Scalars['String']['input']>;
  paragraphNumber?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  religiousTransparency?: InputMaybe<Scalars['ID']['input']>;
  section?: InputMaybe<Scalars['ID']['input']>;
  sexuallyInappropriate?: InputMaybe<Scalars['ID']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type SubSectionRelationResponseCollection = {
  __typename?: 'SubSectionRelationResponseCollection';
  nodes: Array<SubSection>;
};

export type SubSectionTypesResponse = {
  __typename?: 'SubSectionTypesResponse';
  data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  nodes: Array<UploadFile>;
  pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Maybe<UsersPermissionsPermission>>;
  permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  nodes: Array<UsersPermissionsRole>;
  pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  feedbacks: Array<Maybe<Feedback>>;
  feedbacks_connection?: Maybe<FeedbackRelationResponseCollection>;
  provider?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
  verificationToken?: Maybe<Scalars['String']['output']>;
};


export type UsersPermissionsUserFeedbacksArgs = {
  filters?: InputMaybe<FeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserFeedbacks_ConnectionArgs = {
  filters?: InputMaybe<FeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  nodes: Array<UsersPermissionsUser>;
  pageInfo: Pagination;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  deletedAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  feedbacks?: InputMaybe<FeedbackFiltersInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  provider?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  refreshToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
  uuid?: InputMaybe<StringFilterInput>;
  verificationToken?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  feedbacks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  verificationToken?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  nodes: Array<UsersPermissionsUser>;
};

export type LoginMutationVariables = Exact<{
  input: UsersPermissionsLoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, documentId: string, username: string, email?: string | null, confirmed?: boolean | null, blocked?: boolean | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, description?: string | null, type?: string | null } | null } } };

export type RegisterMutationVariables = Exact<{
  input: UsersPermissionsRegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, email?: string | null, username: string, documentId: string, confirmed?: boolean | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, type?: string | null, description?: string | null } | null } } };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword?: { __typename?: 'UsersPermissionsPasswordPayload', ok: boolean } | null };

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UsersPermissionsMe', id: string, documentId: string, username: string, email?: string | null, confirmed?: boolean | null, blocked?: boolean | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, description?: string | null, type?: string | null } | null } | null };

export type CreateFeedbackMutationVariables = Exact<{
  data: FeedbackInput;
}>;


export type CreateFeedbackMutation = { __typename?: 'Mutation', createFeedback?: { __typename?: 'Feedback', documentId: string, suggestedFactCheck?: string | null, suggestedReasoning?: string | null, factClientComments?: string | null, categoryClientComments?: string | null, sexuallyClientComments?: string | null, religiousClientComments?: string | null, factUpvote?: boolean | null, factDownvote?: boolean | null, categoryUpvote?: boolean | null, categoryDownvote?: boolean | null, sexuallyUpvote?: boolean | null, sexuallyDownvote?: boolean | null, religiousUpvote?: boolean | null, religiousDownvote?: boolean | null, suggestedCategory?: Enum_Feedback_Suggestedcategory | null, suggestedRating?: Enum_Feedback_Suggestedrating | null, deletedAt?: any | null, uuid?: string | null, sexuallyFirstPersonPerspective?: boolean | null, sexuallyPhysicalContactType?: any | null, sexuallySetting?: any | null, sexuallyExplicitTermsFound?: boolean | null, sexuallyAnatomicalTermsPresent?: boolean | null, sexuallyContainsDialogue?: boolean | null, sexuallyExplicitTermsList?: any | null, sexuallyAnatomicalTermsList?: any | null, sexuallyChromosomallyDefinedGender?: any | null, sexuallySelfIdentifiedGenders?: any | null, sexuallySexualRelationshipType?: any | null, sexuallyCharacterAge?: any | null, sexuallyEuphemismsList?: any | null, sexuallySuggestivePhrasesList?: any | null, sexuallyPowerImbalancePresent?: boolean | null, sexuallyTone?: any | null, sexuallyExcessiveFocusOnBodyDescription?: boolean | null, sexuallyLanguageOfSecrecyOrConcealment?: boolean | null, sexuallyRoleplayOrFantasyContext?: boolean | null, sexuallyViolenceOverlap?: boolean | null, sexuallyNudityDetected?: any | null, sexuallyNudityExtent?: any | null, sexuallyNudityType?: any | null, sexuallySexualActsDetected?: any | null, sexuallyIntentDetected?: any | null, sexuallyRatingReason?: string | null, religiousReligionKeywordsFound?: boolean | null, religiousKeywordList?: any | null, religiousReligionsNamed?: any | null, religiousFirstOrSecondPersonPronouns?: boolean | null, religiousMiracleMentionedHow?: any | null, religiousExplicitOrImplicit?: any | null, religiousWhoSaysIt?: any | null, religiousTone?: any | null, religiousToneConfidence?: number | null, religiousReligiousSlangFound?: boolean | null, religiousReligiousSlangList?: any | null, religiousHistoricSlursFound?: boolean | null, religiousHistoricSlurList?: any | null, religiousMetaphoricReligiousTermFound?: boolean | null, religiousMetaphoricReligiousTermList?: any | null, religiousDisrespectTowardsReligion?: boolean | null, religiousDisrespectTriggerList?: any | null, religiousDisrespectedReligions?: any | null, religiousComparisonFrameDetected?: boolean | null, religiousComparedReligions?: any | null, religiousDoctrineClaimType?: any | null, religiousFramingStrength?: any | null, religiousDraftStanceByReligion?: any | null, religiousOverallBiasScore?: number | null, religiousReasonNote?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null } | null };

export type Books_ConnectionQueryVariables = Exact<{
  filters?: InputMaybe<BookFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type Books_ConnectionQuery = { __typename?: 'Query', books_connection?: { __typename?: 'BookEntityResponseCollection', pageInfo: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number }, nodes: Array<{ __typename?: 'Book', documentId: string, title?: string | null, subject?: string | null, url?: string | null, author?: any | null, publishedYear?: number | null, description?: string | null, deletedAt?: any | null, uuid?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, tokenCounts?: number | null, priceCounts?: number | null }> } | null };

export type FactChecks_ConnectionQueryVariables = Exact<{
  filters?: InputMaybe<FactCheckFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type FactChecks_ConnectionQuery = { __typename?: 'Query', factChecks_connection?: { __typename?: 'FactCheckEntityResponseCollection', pageInfo: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number }, nodes: Array<{ __typename?: 'FactCheck', ocrText?: string | null, ocrResult?: string | null, isFactuallyCorrect?: boolean | null, documentId: string, createdAt?: any | null, publishedAt?: any | null, totalPrice?: number | null, totalTokens?: any | null, inputPrice?: number | null, inputTokens?: any | null, outputTokens?: any | null, outputPrice?: number | null, reasoning?: string | null, uuid?: string | null, subSection?: { __typename?: 'SubSection', documentId: string, pageNumber?: number | null, asset?: { __typename?: 'Asset', image?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null, feedback?: { __typename?: 'Feedback', factClientComments?: string | null, factDownvote?: boolean | null, factUpvote?: boolean | null } | null } | null, section?: { __typename?: 'Section', tokenCounts?: number | null, priceCounts?: number | null } | null, book?: { __typename?: 'Book', title?: string | null, tokenCounts?: number | null, priceCounts?: number | null } | null }> } | null };

export type CategoryAnalyses_ConnectionQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArg>;
  filters?: InputMaybe<CategoryAnalysisFiltersInput>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CategoryAnalyses_ConnectionQuery = { __typename?: 'Query', categoryAnalyses_connection?: { __typename?: 'CategoryAnalysisEntityResponseCollection', pageInfo: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number }, nodes: Array<{ __typename?: 'CategoryAnalysis', judgeSummary?: string | null, judgeOutput?: string | null, createdAt?: any | null, rating?: Enum_Categoryanalysis_Rating | null, rightistOutput?: string | null, uuid?: string | null, validationPercentage?: number | null, leftistOutput?: string | null, publishedAt?: any | null, documentId: string, category?: Enum_Categoryanalysis_Category | null, totalPrice?: number | null, totalTokens?: any | null, inputPrice?: number | null, inputTokens?: any | null, outputTokens?: any | null, outputPrice?: number | null, observedDeception?: string | null, book?: { __typename?: 'Book', title?: string | null, tokenCounts?: number | null, priceCounts?: number | null } | null, subSection?: { __typename?: 'SubSection', documentId: string, paragraphNumber?: number | null, pageNumber?: number | null, paragraph?: string | null, feedback?: { __typename?: 'Feedback', categoryClientComments?: string | null, categoryDownvote?: boolean | null, categoryUpvote?: boolean | null, suggestedCategory?: Enum_Feedback_Suggestedcategory | null, suggestedRating?: Enum_Feedback_Suggestedrating | null } | null } | null, section?: { __typename?: 'Section', tokenCounts?: number | null, priceCounts?: number | null } | null }> } | null };

export type Sections_ConnectionQueryVariables = Exact<{
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type Sections_ConnectionQuery = { __typename?: 'Query', sections_connection?: { __typename?: 'SectionEntityResponseCollection', nodes: Array<{ __typename?: 'Section', title?: string | null, documentId: string }>, pageInfo: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number } } | null };

export type SexuallyInappropriatesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArg>;
  filters?: InputMaybe<SexuallyInappropriateFiltersInput>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type SexuallyInappropriatesQuery = { __typename?: 'Query', sexuallyInappropriates_connection?: { __typename?: 'SexuallyInappropriateEntityResponseCollection', pageInfo: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number }, nodes: Array<{ __typename?: 'SexuallyInappropriate', documentId: string, aiStages?: any | null, firstPersonPerspective?: boolean | null, physicalContactType?: any | null, setting?: any | null, explicitTermsFound?: boolean | null, anatomicalTermsPresent?: boolean | null, containsDialogue?: boolean | null, explicitTermsList?: any | null, anatomicalTermsList?: any | null, chromosomallyDefinedGender?: any | null, selfIdentifiedGenders?: any | null, sexualRelationshipType?: any | null, characterAge?: any | null, euphemismsList?: any | null, suggestivePhrasesList?: any | null, powerImbalancePresent?: boolean | null, tone?: any | null, excessiveFocusOnBodyDescription?: boolean | null, languageOfSecrecyOrConcealment?: boolean | null, roleplayOrFantasyContext?: boolean | null, violenceOverlap?: boolean | null, nudityDetected?: any | null, nudityExtent?: any | null, nudityType?: any | null, sexualActsDetected?: any | null, intentDetected?: any | null, outputTokens?: any | null, totalTokens?: any | null, inputPrice?: number | null, outputPrice?: number | null, totalPrice?: number | null, finalRating?: number | null, ratingReason?: string | null, inputTokens?: any | null, book?: { __typename?: 'Book', title?: string | null, tokenCounts?: number | null, priceCounts?: number | null } | null, section?: { __typename?: 'Section', tokenCounts?: number | null, priceCounts?: number | null, documentId: string } | null, subSection?: { __typename?: 'SubSection', documentId: string, paragraphNumber?: number | null, pageNumber?: number | null, paragraph?: string | null, feedback?: { __typename?: 'Feedback', suggestedFactCheck?: string | null, suggestedReasoning?: string | null, factClientComments?: string | null, categoryClientComments?: string | null, sexuallyClientComments?: string | null, religiousClientComments?: string | null, factUpvote?: boolean | null, factDownvote?: boolean | null, categoryUpvote?: boolean | null, categoryDownvote?: boolean | null, sexuallyUpvote?: boolean | null, sexuallyDownvote?: boolean | null, religiousUpvote?: boolean | null, religiousDownvote?: boolean | null, suggestedCategory?: Enum_Feedback_Suggestedcategory | null, suggestedRating?: Enum_Feedback_Suggestedrating | null, sexuallyFirstPersonPerspective?: boolean | null, sexuallyPhysicalContactType?: any | null, sexuallySetting?: any | null, sexuallyExplicitTermsFound?: boolean | null, sexuallyAnatomicalTermsPresent?: boolean | null, sexuallyContainsDialogue?: boolean | null, sexuallyExplicitTermsList?: any | null, sexuallyAnatomicalTermsList?: any | null, sexuallyChromosomallyDefinedGender?: any | null, sexuallySelfIdentifiedGenders?: any | null, sexuallySexualRelationshipType?: any | null, sexuallyCharacterAge?: any | null, sexuallyEuphemismsList?: any | null, sexuallySuggestivePhrasesList?: any | null, sexuallyPowerImbalancePresent?: boolean | null, sexuallyTone?: any | null, sexuallyExcessiveFocusOnBodyDescription?: boolean | null, sexuallyLanguageOfSecrecyOrConcealment?: boolean | null, sexuallyRoleplayOrFantasyContext?: boolean | null, sexuallyViolenceOverlap?: boolean | null, sexuallyNudityDetected?: any | null, sexuallyNudityExtent?: any | null, sexuallyNudityType?: any | null, sexuallySexualActsDetected?: any | null, sexuallyIntentDetected?: any | null, sexuallyRatingReason?: string | null, religiousReligionKeywordsFound?: boolean | null, religiousKeywordList?: any | null, religiousReligionsNamed?: any | null, religiousFirstOrSecondPersonPronouns?: boolean | null, religiousMiracleMentionedHow?: any | null, religiousExplicitOrImplicit?: any | null, religiousWhoSaysIt?: any | null, religiousTone?: any | null, religiousToneConfidence?: number | null, religiousReligiousSlangFound?: boolean | null, religiousReligiousSlangList?: any | null, religiousHistoricSlursFound?: boolean | null, religiousHistoricSlurList?: any | null, religiousMetaphoricReligiousTermFound?: boolean | null, religiousMetaphoricReligiousTermList?: any | null, religiousDisrespectTowardsReligion?: boolean | null, religiousDisrespectTriggerList?: any | null, religiousDisrespectedReligions?: any | null, religiousComparisonFrameDetected?: boolean | null, religiousComparedReligions?: any | null, religiousDoctrineClaimType?: any | null, religiousFramingStrength?: any | null, religiousDraftStanceByReligion?: any | null, religiousOverallBiasScore?: number | null, religiousReasonNote?: string | null, sexuallyFinalRating?: number | null } | null } | null }> } | null };

export type ReligiousTransparencies_ConnectionQueryVariables = Exact<{
  filters?: InputMaybe<ReligiousTransparencyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type ReligiousTransparencies_ConnectionQuery = { __typename?: 'Query', religiousTransparencies_connection?: { __typename?: 'ReligiousTransparencyEntityResponseCollection', pageInfo: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number }, nodes: Array<{ __typename?: 'ReligiousTransparency', documentId: string, aiStages?: any | null, religionKeywordsFound?: boolean | null, keywordList?: any | null, religionsNamed?: any | null, firstOrSecondPersonPronouns?: boolean | null, miracleMentionedHow?: any | null, explicitOrImplicit?: any | null, whoSaysIt?: any | null, tone?: any | null, toneConfidence?: number | null, religiousSlangFound?: boolean | null, religiousSlangList?: any | null, historicSlursFound?: boolean | null, historicSlurList?: any | null, metaphoricReligiousTermFound?: boolean | null, metaphoricReligiousTermList?: any | null, disrespectTowardsReligion?: boolean | null, disrespectTriggerList?: any | null, disrespectedReligions?: any | null, comparisonFrameDetected?: boolean | null, comparedReligions?: any | null, doctrineClaimType?: any | null, framingStrength?: any | null, draftStanceByReligion?: any | null, overallBiasScore?: number | null, reasonNote?: string | null, outputTokens?: any | null, totalTokens?: any | null, inputPrice?: number | null, outputPrice?: number | null, totalPrice?: number | null, inputTokens?: any | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, book?: { __typename?: 'Book', title?: string | null, tokenCounts?: number | null, priceCounts?: number | null } | null, section?: { __typename?: 'Section', tokenCounts?: number | null, documentId: string, priceCounts?: number | null } | null, subSection?: { __typename?: 'SubSection', documentId: string, paragraphNumber?: number | null, pageNumber?: number | null, paragraph?: string | null, feedback?: { __typename?: 'Feedback', documentId: string, religiousClientComments?: string | null, religiousUpvote?: boolean | null, religiousDownvote?: boolean | null, uuid?: string | null, religiousReligionKeywordsFound?: boolean | null, religiousKeywordList?: any | null, religiousReligionsNamed?: any | null, religiousFirstOrSecondPersonPronouns?: boolean | null, religiousMiracleMentionedHow?: any | null, religiousExplicitOrImplicit?: any | null, religiousWhoSaysIt?: any | null, religiousTone?: any | null, religiousToneConfidence?: number | null, religiousReligiousSlangFound?: boolean | null, religiousReligiousSlangList?: any | null, religiousHistoricSlursFound?: boolean | null, religiousHistoricSlurList?: any | null, religiousMetaphoricReligiousTermFound?: boolean | null, religiousMetaphoricReligiousTermList?: any | null, religiousDisrespectTowardsReligion?: boolean | null, religiousDisrespectTriggerList?: any | null, religiousDisrespectedReligions?: any | null, religiousComparisonFrameDetected?: boolean | null, religiousComparedReligions?: any | null, religiousDoctrineClaimType?: any | null, religiousFramingStrength?: any | null, religiousDraftStanceByReligion?: any | null, religiousOverallBiasScore?: number | null, religiousReasonNote?: string | null, religiousRatingReason?: string | null, religiousFinalRating?: number | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null } | null } | null }> } | null };


export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersPermissionsLoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jwt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Register"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersPermissionsRegisterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jwt"}}]}}]}}]} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const ForgotPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ForgotPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forgotPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"passwordConfirmation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"passwordConfirmation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"passwordConfirmation"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jwt"}}]}}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const CreateFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedFactCheck"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedReasoning"}},{"kind":"Field","name":{"kind":"Name","value":"factClientComments"}},{"kind":"Field","name":{"kind":"Name","value":"categoryClientComments"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyClientComments"}},{"kind":"Field","name":{"kind":"Name","value":"religiousClientComments"}},{"kind":"Field","name":{"kind":"Name","value":"factUpvote"}},{"kind":"Field","name":{"kind":"Name","value":"factDownvote"}},{"kind":"Field","name":{"kind":"Name","value":"categoryUpvote"}},{"kind":"Field","name":{"kind":"Name","value":"categoryDownvote"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyUpvote"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyDownvote"}},{"kind":"Field","name":{"kind":"Name","value":"religiousUpvote"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDownvote"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedCategory"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedRating"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyFirstPersonPerspective"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyPhysicalContactType"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallySetting"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyExplicitTermsFound"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyAnatomicalTermsPresent"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyContainsDialogue"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyExplicitTermsList"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyAnatomicalTermsList"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyChromosomallyDefinedGender"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallySelfIdentifiedGenders"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallySexualRelationshipType"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyCharacterAge"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyEuphemismsList"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallySuggestivePhrasesList"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyPowerImbalancePresent"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyTone"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyExcessiveFocusOnBodyDescription"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyLanguageOfSecrecyOrConcealment"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyRoleplayOrFantasyContext"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyViolenceOverlap"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyNudityDetected"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyNudityExtent"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyNudityType"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallySexualActsDetected"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyIntentDetected"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyRatingReason"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReligionKeywordsFound"}},{"kind":"Field","name":{"kind":"Name","value":"religiousKeywordList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReligionsNamed"}},{"kind":"Field","name":{"kind":"Name","value":"religiousFirstOrSecondPersonPronouns"}},{"kind":"Field","name":{"kind":"Name","value":"religiousMiracleMentionedHow"}},{"kind":"Field","name":{"kind":"Name","value":"religiousExplicitOrImplicit"}},{"kind":"Field","name":{"kind":"Name","value":"religiousWhoSaysIt"}},{"kind":"Field","name":{"kind":"Name","value":"religiousTone"}},{"kind":"Field","name":{"kind":"Name","value":"religiousToneConfidence"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReligiousSlangFound"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReligiousSlangList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousHistoricSlursFound"}},{"kind":"Field","name":{"kind":"Name","value":"religiousHistoricSlurList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousMetaphoricReligiousTermFound"}},{"kind":"Field","name":{"kind":"Name","value":"religiousMetaphoricReligiousTermList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDisrespectTowardsReligion"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDisrespectTriggerList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDisrespectedReligions"}},{"kind":"Field","name":{"kind":"Name","value":"religiousComparisonFrameDetected"}},{"kind":"Field","name":{"kind":"Name","value":"religiousComparedReligions"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDoctrineClaimType"}},{"kind":"Field","name":{"kind":"Name","value":"religiousFramingStrength"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDraftStanceByReligion"}},{"kind":"Field","name":{"kind":"Name","value":"religiousOverallBiasScore"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReasonNote"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]} as unknown as DocumentNode<CreateFeedbackMutation, CreateFeedbackMutationVariables>;
export const Books_ConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Books_connection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BookFiltersInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationArg"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"books_connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"publishedYear"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"tokenCounts"}},{"kind":"Field","name":{"kind":"Name","value":"priceCounts"}}]}}]}}]}}]} as unknown as DocumentNode<Books_ConnectionQuery, Books_ConnectionQueryVariables>;
export const FactChecks_ConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FactChecks_connection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FactCheckFiltersInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationArg"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factChecks_connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ocrText"}},{"kind":"Field","name":{"kind":"Name","value":"ocrResult"}},{"kind":"Field","name":{"kind":"Name","value":"isFactuallyCorrect"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalTokens"}},{"kind":"Field","name":{"kind":"Name","value":"inputPrice"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputPrice"}},{"kind":"Field","name":{"kind":"Name","value":"reasoning"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"subSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factClientComments"}},{"kind":"Field","name":{"kind":"Name","value":"factDownvote"}},{"kind":"Field","name":{"kind":"Name","value":"factUpvote"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"section"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenCounts"}},{"kind":"Field","name":{"kind":"Name","value":"priceCounts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tokenCounts"}},{"kind":"Field","name":{"kind":"Name","value":"priceCounts"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FactChecks_ConnectionQuery, FactChecks_ConnectionQueryVariables>;
export const CategoryAnalyses_ConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CategoryAnalyses_connection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationArg"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryAnalysisFiltersInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryAnalyses_connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tokenCounts"}},{"kind":"Field","name":{"kind":"Name","value":"priceCounts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"paragraphNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"paragraph"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryClientComments"}},{"kind":"Field","name":{"kind":"Name","value":"categoryDownvote"}},{"kind":"Field","name":{"kind":"Name","value":"categoryUpvote"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedCategory"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedRating"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"section"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenCounts"}},{"kind":"Field","name":{"kind":"Name","value":"priceCounts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"judgeSummary"}},{"kind":"Field","name":{"kind":"Name","value":"judgeOutput"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"rightistOutput"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"validationPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"leftistOutput"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalTokens"}},{"kind":"Field","name":{"kind":"Name","value":"inputPrice"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputPrice"}},{"kind":"Field","name":{"kind":"Name","value":"observedDeception"}}]}}]}}]}}]} as unknown as DocumentNode<CategoryAnalyses_ConnectionQuery, CategoryAnalyses_ConnectionQueryVariables>;
export const Sections_ConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Sections_connection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SectionFiltersInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationArg"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sections_connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}}]}}]}}]}}]} as unknown as DocumentNode<Sections_ConnectionQuery, Sections_ConnectionQueryVariables>;
export const SexuallyInappropriatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SexuallyInappropriates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationArg"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SexuallyInappropriateFiltersInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sexuallyInappropriates_connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"aiStages"}},{"kind":"Field","name":{"kind":"Name","value":"firstPersonPerspective"}},{"kind":"Field","name":{"kind":"Name","value":"physicalContactType"}},{"kind":"Field","name":{"kind":"Name","value":"setting"}},{"kind":"Field","name":{"kind":"Name","value":"explicitTermsFound"}},{"kind":"Field","name":{"kind":"Name","value":"anatomicalTermsPresent"}},{"kind":"Field","name":{"kind":"Name","value":"containsDialogue"}},{"kind":"Field","name":{"kind":"Name","value":"explicitTermsList"}},{"kind":"Field","name":{"kind":"Name","value":"anatomicalTermsList"}},{"kind":"Field","name":{"kind":"Name","value":"chromosomallyDefinedGender"}},{"kind":"Field","name":{"kind":"Name","value":"selfIdentifiedGenders"}},{"kind":"Field","name":{"kind":"Name","value":"sexualRelationshipType"}},{"kind":"Field","name":{"kind":"Name","value":"characterAge"}},{"kind":"Field","name":{"kind":"Name","value":"euphemismsList"}},{"kind":"Field","name":{"kind":"Name","value":"suggestivePhrasesList"}},{"kind":"Field","name":{"kind":"Name","value":"powerImbalancePresent"}},{"kind":"Field","name":{"kind":"Name","value":"tone"}},{"kind":"Field","name":{"kind":"Name","value":"excessiveFocusOnBodyDescription"}},{"kind":"Field","name":{"kind":"Name","value":"languageOfSecrecyOrConcealment"}},{"kind":"Field","name":{"kind":"Name","value":"roleplayOrFantasyContext"}},{"kind":"Field","name":{"kind":"Name","value":"violenceOverlap"}},{"kind":"Field","name":{"kind":"Name","value":"nudityDetected"}},{"kind":"Field","name":{"kind":"Name","value":"nudityExtent"}},{"kind":"Field","name":{"kind":"Name","value":"nudityType"}},{"kind":"Field","name":{"kind":"Name","value":"sexualActsDetected"}},{"kind":"Field","name":{"kind":"Name","value":"intentDetected"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"totalTokens"}},{"kind":"Field","name":{"kind":"Name","value":"inputPrice"}},{"kind":"Field","name":{"kind":"Name","value":"outputPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tokenCounts"}},{"kind":"Field","name":{"kind":"Name","value":"priceCounts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"section"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenCounts"}},{"kind":"Field","name":{"kind":"Name","value":"priceCounts"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"finalRating"}},{"kind":"Field","name":{"kind":"Name","value":"ratingReason"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"subSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"paragraphNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"paragraph"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestedFactCheck"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedReasoning"}},{"kind":"Field","name":{"kind":"Name","value":"factClientComments"}},{"kind":"Field","name":{"kind":"Name","value":"categoryClientComments"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyClientComments"}},{"kind":"Field","name":{"kind":"Name","value":"religiousClientComments"}},{"kind":"Field","name":{"kind":"Name","value":"factUpvote"}},{"kind":"Field","name":{"kind":"Name","value":"factDownvote"}},{"kind":"Field","name":{"kind":"Name","value":"categoryUpvote"}},{"kind":"Field","name":{"kind":"Name","value":"categoryDownvote"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyUpvote"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyDownvote"}},{"kind":"Field","name":{"kind":"Name","value":"religiousUpvote"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDownvote"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedCategory"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedRating"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyFirstPersonPerspective"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyPhysicalContactType"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallySetting"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyExplicitTermsFound"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyAnatomicalTermsPresent"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyContainsDialogue"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyExplicitTermsList"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyAnatomicalTermsList"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyChromosomallyDefinedGender"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallySelfIdentifiedGenders"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallySexualRelationshipType"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyCharacterAge"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyEuphemismsList"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallySuggestivePhrasesList"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyPowerImbalancePresent"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyTone"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyExcessiveFocusOnBodyDescription"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyLanguageOfSecrecyOrConcealment"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyRoleplayOrFantasyContext"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyViolenceOverlap"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyNudityDetected"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyNudityExtent"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyNudityType"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallySexualActsDetected"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyIntentDetected"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyRatingReason"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReligionKeywordsFound"}},{"kind":"Field","name":{"kind":"Name","value":"religiousKeywordList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReligionsNamed"}},{"kind":"Field","name":{"kind":"Name","value":"religiousFirstOrSecondPersonPronouns"}},{"kind":"Field","name":{"kind":"Name","value":"religiousMiracleMentionedHow"}},{"kind":"Field","name":{"kind":"Name","value":"religiousExplicitOrImplicit"}},{"kind":"Field","name":{"kind":"Name","value":"religiousWhoSaysIt"}},{"kind":"Field","name":{"kind":"Name","value":"religiousTone"}},{"kind":"Field","name":{"kind":"Name","value":"religiousToneConfidence"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReligiousSlangFound"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReligiousSlangList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousHistoricSlursFound"}},{"kind":"Field","name":{"kind":"Name","value":"religiousHistoricSlurList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousMetaphoricReligiousTermFound"}},{"kind":"Field","name":{"kind":"Name","value":"religiousMetaphoricReligiousTermList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDisrespectTowardsReligion"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDisrespectTriggerList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDisrespectedReligions"}},{"kind":"Field","name":{"kind":"Name","value":"religiousComparisonFrameDetected"}},{"kind":"Field","name":{"kind":"Name","value":"religiousComparedReligions"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDoctrineClaimType"}},{"kind":"Field","name":{"kind":"Name","value":"religiousFramingStrength"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDraftStanceByReligion"}},{"kind":"Field","name":{"kind":"Name","value":"religiousOverallBiasScore"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReasonNote"}},{"kind":"Field","name":{"kind":"Name","value":"sexuallyFinalRating"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SexuallyInappropriatesQuery, SexuallyInappropriatesQueryVariables>;
export const ReligiousTransparencies_ConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReligiousTransparencies_connection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReligiousTransparencyFiltersInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationArg"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"religiousTransparencies_connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"pageCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"aiStages"}},{"kind":"Field","name":{"kind":"Name","value":"religionKeywordsFound"}},{"kind":"Field","name":{"kind":"Name","value":"keywordList"}},{"kind":"Field","name":{"kind":"Name","value":"religionsNamed"}},{"kind":"Field","name":{"kind":"Name","value":"firstOrSecondPersonPronouns"}},{"kind":"Field","name":{"kind":"Name","value":"miracleMentionedHow"}},{"kind":"Field","name":{"kind":"Name","value":"explicitOrImplicit"}},{"kind":"Field","name":{"kind":"Name","value":"whoSaysIt"}},{"kind":"Field","name":{"kind":"Name","value":"tone"}},{"kind":"Field","name":{"kind":"Name","value":"toneConfidence"}},{"kind":"Field","name":{"kind":"Name","value":"religiousSlangFound"}},{"kind":"Field","name":{"kind":"Name","value":"religiousSlangList"}},{"kind":"Field","name":{"kind":"Name","value":"historicSlursFound"}},{"kind":"Field","name":{"kind":"Name","value":"historicSlurList"}},{"kind":"Field","name":{"kind":"Name","value":"metaphoricReligiousTermFound"}},{"kind":"Field","name":{"kind":"Name","value":"metaphoricReligiousTermList"}},{"kind":"Field","name":{"kind":"Name","value":"disrespectTowardsReligion"}},{"kind":"Field","name":{"kind":"Name","value":"disrespectTriggerList"}},{"kind":"Field","name":{"kind":"Name","value":"disrespectedReligions"}},{"kind":"Field","name":{"kind":"Name","value":"comparisonFrameDetected"}},{"kind":"Field","name":{"kind":"Name","value":"comparedReligions"}},{"kind":"Field","name":{"kind":"Name","value":"doctrineClaimType"}},{"kind":"Field","name":{"kind":"Name","value":"framingStrength"}},{"kind":"Field","name":{"kind":"Name","value":"draftStanceByReligion"}},{"kind":"Field","name":{"kind":"Name","value":"overallBiasScore"}},{"kind":"Field","name":{"kind":"Name","value":"reasonNote"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"totalTokens"}},{"kind":"Field","name":{"kind":"Name","value":"inputPrice"}},{"kind":"Field","name":{"kind":"Name","value":"outputPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tokenCounts"}},{"kind":"Field","name":{"kind":"Name","value":"priceCounts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"section"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenCounts"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"priceCounts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"paragraphNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"paragraph"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"religiousClientComments"}},{"kind":"Field","name":{"kind":"Name","value":"religiousUpvote"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDownvote"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReligionKeywordsFound"}},{"kind":"Field","name":{"kind":"Name","value":"religiousKeywordList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReligionsNamed"}},{"kind":"Field","name":{"kind":"Name","value":"religiousFirstOrSecondPersonPronouns"}},{"kind":"Field","name":{"kind":"Name","value":"religiousMiracleMentionedHow"}},{"kind":"Field","name":{"kind":"Name","value":"religiousExplicitOrImplicit"}},{"kind":"Field","name":{"kind":"Name","value":"religiousWhoSaysIt"}},{"kind":"Field","name":{"kind":"Name","value":"religiousTone"}},{"kind":"Field","name":{"kind":"Name","value":"religiousToneConfidence"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReligiousSlangFound"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReligiousSlangList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousHistoricSlursFound"}},{"kind":"Field","name":{"kind":"Name","value":"religiousHistoricSlurList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousMetaphoricReligiousTermFound"}},{"kind":"Field","name":{"kind":"Name","value":"religiousMetaphoricReligiousTermList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDisrespectTowardsReligion"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDisrespectTriggerList"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDisrespectedReligions"}},{"kind":"Field","name":{"kind":"Name","value":"religiousComparisonFrameDetected"}},{"kind":"Field","name":{"kind":"Name","value":"religiousComparedReligions"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDoctrineClaimType"}},{"kind":"Field","name":{"kind":"Name","value":"religiousFramingStrength"}},{"kind":"Field","name":{"kind":"Name","value":"religiousDraftStanceByReligion"}},{"kind":"Field","name":{"kind":"Name","value":"religiousOverallBiasScore"}},{"kind":"Field","name":{"kind":"Name","value":"religiousReasonNote"}},{"kind":"Field","name":{"kind":"Name","value":"religiousRatingReason"}},{"kind":"Field","name":{"kind":"Name","value":"religiousFinalRating"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}}]} as unknown as DocumentNode<ReligiousTransparencies_ConnectionQuery, ReligiousTransparencies_ConnectionQueryVariables>;